import React, { FC, useEffect, useMemo, useState } from "react";
import { PosLayout } from "../../../components/layouts/pos-layout/PosLayout";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  MenuItem,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { getPDFLink } from "../../../util/pdf-functions";
import { pdf } from "@react-pdf/renderer";
import dayjs from "dayjs";
import axios from "axios";
import { BASE_URL } from "../../../configs/apiConfig";
import { ICustomerBill } from "../../../typings/interfaces/responses/customer-bills-response";
// import { PDFDownloadLink } from "@react-pdf/renderer"; //added to test to total reports

import CustomerDetailSection from "../../../components/common/pos/customer-detail-section/customer-detail-section";
import { formatCurrency, formatUSDate } from "../../../util/common-functions";
import TopRightButton from "../../../components/common/top-right-button/top-right-button";
import { useNavigate, useParams } from "react-router-dom";
import PdfViewModal from "../../../components/pos/pdf-view-modal/pdf-view-modal";
import PDFDownloadAccessModal from "../../../components/pos/pdf-download-access-modal/PDFDownloadAccessModal";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getAllCustomerInsightsAction,
  getCustomerActivitiesByDayAction,
  getCustomerOutstandingAction,
} from "../../../redux/actions/customerInsightsAction";
import { getAllCustomerLatestBillDetailsAction } from "../../../redux/actions/customerLatestBillDetailsAction";
import {
  getAllCustomerCurrentYearServiceUsageAction,
  getAllCustomerAllTimeServiceUsageAction,
} from "../../../redux/actions/customerServiceUsageAction";
import { useSnackbarContext } from "../../../providers/SnackbarProvider";
import { getAllCustomerAvgSpendingsAction } from "../../../redux/actions/customerAvgSpendingsAction";
import {
  getCustomerRefundStatsAction,
  getCustomerRefundStatsByYearAction,
  getCustomerRefundHistoryAction,
} from "../../../redux/actions/customerRefundAction";
import { getCustomerReportHistoryAction } from "../../../redux/actions/customerReportHistoryAction";
import {
  generateCustomerReportAction,
  getCustomerGeneratedReportsAction,
  getCustomerMonthlyInvoicesAction,
  getIsMonthlyCustomerAction,
} from "../../../redux/actions/customerGeneratedReportsAction";
import { ICustomerGeneratedReport } from "../../../typings/interfaces/responses/customer-generated-report-response";
import { IMonthlyInvoice } from "../../../typings/interfaces/responses/monthly-invoice-response";
import { getCustomerReportDataAction } from "../../../redux/actions/getCustomerReportDataAction";
import { Colors } from "../../../configs/colors";
import { CustomerSliceAction } from "../../../redux/slice/customerSlice";
import { ExpenditureReport } from "./ExpenditureReport";
import CustomDateTimePicker from "../../../components/atoms/custom-date-time-picker/custom-date-time-picker";
import AddNoteModal from "./AddNoteModal";
import { DateRange } from "react-day-picker";
import { DatePicker } from "../../../components/atoms/custom-date-time-picker/DateRangePicker";
import PDFPrintAccessModal from "../../../components/pos/pdf-print-modal/Pdf-print-modal";
import ManagerCodeModal from "../../../components/common/manager-code-modal/ManagerCodeModal";
import PatternsTab from "./PatternsTab";
// import FinancialMonthlyReport from "./FinancialMonthlyReport"; //added to test to total reports
// import FinancialAnnualReport from "./FinancialAnnualReport"; //added to test to total reports
// import FinancialCustomReport from "./FinancialCustomReport"; //added to test to total reports
// import DeptWisePieceCountMonthlyReport from "./DeptWisePieceCountMonthlyReport"; //added to test to total reports
// import DeptWisePieceCountAnnualReport from "./DeptWisePieceCountAnnualReport"; //added to test to total reports
// import DeptWisePieceCountCustomReport from "./DeptWisePieceCountCustomReport"; //added to test to total reports
// import DeptwiseSalesMonthlyReport from "./DeptwiseSalesMonthlyReport"; //added to test to total reports
// import DeptwiseSalesAnnualReport from "./DeptwiseSalesAnnualReport"; //added to test to total reports
// import DeptwiseSalesCustomReport from "./DeptwiseSalesCustomReport"; //added to test to total reports

export interface ICustomerAnalysisProps { }

// ─── pie-gradient helper ──────────────────────────────────────────────────────
function buildPieGradient(items: Array<{ color: string; value: number }>) {
  const total = items.reduce((s, i) => s + i.value, 0);
  if (total <= 0) return "#E8EAEC";
  let start = 0;
  return items
    .map((item) => {
      const deg = (item.value / total) * 360;
      const end = start + deg;
      const seg = `${item.color} ${start}deg ${end}deg`;
      start = end;
      return seg;
    })
    .join(", ");
}

const SERVICE_COLORS = [
  Colors.PRIMARY, Colors.SECONDARY, "#7A8793", "#B7BDC3", "#CC7700", "#9C27B0", "#E65100",
];

function toneColor(tone?: "green" | "blue" | "red") {
  if (tone === "green") return Colors.PRIMARY;
  if (tone === "blue") return Colors.SECONDARY;
  if (tone === "red") return Colors.BROWN;
  return Colors.MAIN_GRAY;
}

function DollarSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="2" x2="12" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}
function CreditCardSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="5" width="19" height="14" rx="2.5" /><line x1="2.5" y1="10" x2="21.5" y2="10" /><line x1="7" y1="15" x2="10" y2="15" />
    </svg>
  );
}
function EyeSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" /><path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z" />
    </svg>
  );
}
function EmailSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" />
    </svg>
  );
}
function PrintSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="9" width="12" height="8" /><path d="M6 9V4h12v5" /><path d="M6 17v3h12v-3" />
    </svg>
  );
}
function DocSvg() {
  return (
    <svg width="1.375rem" height="1.375rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" /><line x1="7" y1="10" x2="17" y2="10" /><line x1="7" y1="14" x2="14" y2="14" />
    </svg>
  );
}
function XSvg() {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6 6 18" /><path d="m6 6 12 12" />
    </svg>
  );
}
function PenSvg() {
  return (
    <svg width="1.1rem" height="1.1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
  );
}

function StatCard({ label, value, helper, tone, Icon }: { label: string; value: string; helper?: string; tone?: "green" | "blue" | "red"; Icon?: React.FC }) {
  const c = toneColor(tone);
  return (
    <Box sx={{ borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)", transition: "box-shadow 0.2s", "&:hover": { boxShadow: "0 0.25rem 0.75rem rgba(0,0,0,0.12)" } }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem" }}>
        <Box>
          <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>{label}</Typography>
          <Typography sx={{ mt: "0.5rem", fontSize: "var(--fs-lg)", fontWeight: "bold", color: c, lineHeight: 1 }}>{value}</Typography>
          {helper && <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>{helper}</Typography>}
        </Box>
        {Icon && <Box sx={{ borderRadius: "1rem", background: Colors.BACKSHADE_GRAY, p: "0.75rem", color: c, flexShrink: 0 }}><Icon /></Box>}
      </Box>
    </Box>
  );
}

function UsageCard({ title, items, totalCount, totalSpend }: { title: string; items: Array<{ label: string; value: number; color: string }>; totalCount: number; totalSpend: string }) {
  const safe = items.length > 0 ? items : [{ label: "No Data", value: 1, color: "#E8EAEC" }];
  const total = safe.reduce((s, i) => s + i.value, 0);
  const top = safe.reduce((t, i) => i.value > t.value ? i : t, safe[0]);
  return (
    <Box sx={{ borderRadius: "1rem", border: `1px solid ${Colors.ACCENT_GRAY}`, background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.75rem", mb: "0.75rem" }}>
        <Box>
          <Typography sx={{ fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>{title}</Typography>
          <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}99` }}>Service mix by order count</Typography>
        </Box>
        <Box sx={{ borderRadius: "999px", background: Colors.BACKSHADE_GRAY, px: "0.75rem", py: "0.25rem", fontSize: "var(--fs-2xs)", fontWeight: "bold", color: Colors.MAIN_GRAY, whiteSpace: "nowrap", flexShrink: 0 }}>
          Top: {top.label}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mb: "0.75rem" }}>
        <Box sx={{ position: "relative", width: "9rem", height: "9rem", borderRadius: "50%", background: Colors.BACKSHADE_GRAY, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Box sx={{ position: "absolute", inset: "0.5rem", borderRadius: "50%", background: `conic-gradient(${buildPieGradient(safe)})` }} />
          <Box sx={{ position: "relative", width: "6rem", height: "6rem", borderRadius: "50%", background: Colors.WHITE, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: `1px solid ${Colors.ACCENT_GRAY}`, boxShadow: "0 0.25rem 0.75rem rgba(0,0,0,0.1)" }}>
            <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>Orders</Typography>
            <Typography sx={{ fontSize: "var(--fs-lg)", fontWeight: "bold", color: Colors.MAIN_GRAY, lineHeight: 1 }}>{totalCount}</Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", mb: "0.75rem" }}>
        {[{ label: "Total Spend", val: totalSpend }, { label: "Categories", val: String(safe.length) }].map(({ label, val }) => (
          <Box key={label} sx={{ borderRadius: "0.75rem", background: Colors.BACKSHADE_GRAY, p: "0.75rem" }}>
            <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>{label}</Typography>
            <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-lg)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>{val}</Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {safe.map((item) => {
          const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
          return (
            <Box key={item.label}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "0.2rem" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <Box sx={{ width: "0.75rem", height: "0.75rem", borderRadius: "50%", background: item.color }} />
                  <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: "bold", color: `${Colors.MAIN_GRAY}B3` }}>{item.label}</Typography>
                </Box>
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: "bold", color: `${Colors.MAIN_GRAY}B3` }}>{item.value} · {pct}%</Typography>
              </Box>
              <Box sx={{ height: "0.5rem", borderRadius: "999px", background: "#E8EAEC", overflow: "hidden" }}>
                <Box sx={{ height: "100%", borderRadius: "999px", background: item.color, width: `${pct}%` }} />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

function SplitTotalCard({ title, currentValue, lifetimeValue, currentHelper, lifetimeHelper, tone }: { title: string; currentValue: number; lifetimeValue: number; currentHelper: string; lifetimeHelper: string; tone?: "green" | "blue" | "red" }) {
  const c = toneColor(tone);
  return (
    <Box sx={{ borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>{title}</Typography>
      <Box sx={{ mt: "0.75rem", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
        <Box>
          <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: `${Colors.MAIN_GRAY}80` }}>Current Year</Typography>
          <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-lg)", fontWeight: "bold", color: c }}>${currentValue.toFixed(2)}</Typography>
          <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>{currentHelper}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: `${Colors.MAIN_GRAY}80` }}>Lifetime</Typography>
          <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-lg)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>${lifetimeValue.toFixed(2)}</Typography>
          <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>{lifetimeHelper}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

function InsightCard({ label, value, helper, tone }: { label: string; value: string; helper?: string; tone?: "green" | "blue" | "red" }) {
  const c = toneColor(tone);
  return (
    <Box sx={{ borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: `${Colors.MAIN_GRAY}8C` }}>{label}</Typography>
      <Typography sx={{ mt: "0.5rem", fontSize: "var(--fs-lg)", fontWeight: "bold", color: c }}>{value}</Typography>
      {helper && <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}99` }}>{helper}</Typography>}
    </Box>
  );
}

function ReportActionBtn({ title, children, onClick }: { title: string; children: React.ReactNode; onClick?: () => void }) {
  return (
    <Box component="button" title={title} onClick={onClick} sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "2.25rem", height: "2.25rem", borderRadius: "0.5rem", border: `1px solid ${Colors.PRIMARY}`, color: Colors.PRIMARY, background: Colors.WHITE, cursor: "pointer", "&:hover": { background: `${Colors.PRIMARY}1A` } }}>
      {children}
    </Box>
  );
}

function ReportRow({ name, showDocButton, onView, onEmail, onPrint }: { name: string; showDocButton?: boolean; onView?: () => void; onEmail?: () => void; onPrint?: () => void }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "0.75rem", background: Colors.WHITE, px: "1rem", py: "0.75rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.06)", mb: "0.5rem" }}>
      <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>{name}</Typography>
      <Box sx={{ display: "flex", gap: "0.5rem" }}>
        {showDocButton && <ReportActionBtn title="Document" onClick={onView}><DocSvg /></ReportActionBtn>}
        <ReportActionBtn title="View" onClick={onView}><EyeSvg /></ReportActionBtn>
        <ReportActionBtn title="Email" onClick={onEmail}><EmailSvg /></ReportActionBtn>
        <ReportActionBtn title="Print" onClick={onPrint}><PrintSvg /></ReportActionBtn>
      </Box>
    </Box>
  );
}

const CustomerAnalysisScreen: FC<ICustomerAnalysisProps> = ({ }) => {
  // 0=Analysis 1=Patterns 2=Reports 3=Claims
  const [selectedTab, setSelectedTab] = useState(0);
  const [reportsUnlocked, setReportsUnlocked] = useState(false);
  const [showManagerModal, setShowManagerModal] = useState(false);
  const [selectedRefundRow, setSelectedRefundRow] = useState<any>(null);

  const dispatch = useAppDispatch();
  const Snackbar = useSnackbarContext();
  const [, setPDFLink] = React.useState<string | null>(null);

  const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined);
  const [selectedReportType, setSelectedReportType] = useState("Annual Expenditure Report");
  const [showAddNote, setShowAddNote] = useState(false);
  const [reportNotes, setReportNotes] = useState<string>("");
  const [showInvoicePanel, setShowInvoicePanel] = useState(false);
  const [reportBills, setReportBills] = useState<ICustomerBill[]>([]);
  const [selectedBillIds, setSelectedBillIds] = useState<Set<number>>(new Set());
  const [ticketSearch, setTicketSearch] = useState("");
  const [loadingBills, setLoadingBills] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [downloadAccessOpen, setDownloadAccessOpen] = useState(false);
  const [printAccessOpen, setPrintAccessOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState<string | null>(null);
  const [selectedReportData, setSelectedReportData] = useState<ICustomerGeneratedReport | null>(null);

  const reportTypes = [
    "Annual Expenditure Report",
    "Monthly Expenditure Report",
    "Custom Expenditure Report",
    "Annual Outstanding Report",
    "Monthly Outstanding Report",
    "Custom Outstanding Report",
    "Annual Invoice",
    "Monthly Invoice",
    "Custom Invoice",
  ];

  const startDate = dateRange?.from ?? null;

  const handleReportsTab = () => {
    if (reportsUnlocked) { setSelectedTab(2); return; }
    setShowManagerModal(true);
  };

  const params = useParams();
  const customerId = params.id;
  const { cartMode } = useAppSelector((state) => state.cart);
  const { user } = useAppSelector((state) => state.auth);

  const {
    customerInsights,
    customerInsightsError,
    customerLatestBillDetails,
    customerLatestBillDetailsError,
    customerAvgSpendings,
    customerAvgSpendingsError,
    customerActivitiesByDay,
    customerActivitiesByDayError,
    customerOutstandingError,
    customerOutstanding,
    customerCurrentYearServiceUsage,
    customerAllTimeServiceUsage,
    customerRefundStats,
    customerRefundStatsByYear,
    customerRefundHistory,
    customerGeneratedReports,
    generateReportLoading,
    customerMonthlyInvoices,
    isMonthlyCustomer,
    customerReportData,
  } = useAppSelector((state) => state.customer);

  useEffect(() => {
    if (customerId) {
      dispatch(getAllCustomerInsightsAction(Number(customerId)));
      dispatch(getAllCustomerLatestBillDetailsAction(Number(customerId)));

      dispatch(
        getAllCustomerAvgSpendingsAction({
          customerId: Number(customerId),
          startDate: null,
          endDate: null,
        })
      );

      dispatch(getCustomerActivitiesByDayAction(Number(customerId)));

      dispatch(getCustomerOutstandingAction(Number(customerId)));

      dispatch(getAllCustomerCurrentYearServiceUsageAction(Number(customerId)));
      dispatch(getAllCustomerAllTimeServiceUsageAction(Number(customerId)));

      dispatch(getCustomerRefundStatsAction(Number(customerId)));
      dispatch(
        getCustomerRefundStatsByYearAction({
          customerId: Number(customerId),
          year: new Date().getFullYear(),
        })
      );
      dispatch(getCustomerRefundHistoryAction(Number(customerId)));
      dispatch(getCustomerReportHistoryAction(Number(customerId)));
      dispatch(getCustomerGeneratedReportsAction(Number(customerId)));
      dispatch(getCustomerMonthlyInvoicesAction(Number(customerId)));
      dispatch(getIsMonthlyCustomerAction(Number(customerId)));
    }
  }, [customerId]);

  useEffect(() => {
    getPDFLink().then((link) => {
      setPDFLink(link);
    });
  }, []);

  useEffect(() => {
    return () => {
      dispatch(CustomerSliceAction.clearCustomerInsights());
    };
  }, []);

  useEffect(() => {
    setShowInvoicePanel(false);
    setReportBills([]);
    setSelectedBillIds(new Set());
    setTicketSearch("");
  }, [selectedReportType, dateRange]);

  useEffect(() => {
    if (customerInsightsError) Snackbar.showSnackbar(customerInsightsError, "error");
    if (customerLatestBillDetailsError) Snackbar.showSnackbar(customerLatestBillDetailsError, "error");
    if (customerAvgSpendingsError) Snackbar.showSnackbar(customerAvgSpendingsError, "error");
    if (customerActivitiesByDayError) Snackbar.showSnackbar(customerActivitiesByDayError, "error");
    if (customerOutstandingError) Snackbar.showSnackbar(customerOutstandingError, "error");
  }, [customerInsightsError, customerLatestBillDetailsError, customerAvgSpendingsError, customerActivitiesByDayError, customerOutstandingError]);

  const navigate = useNavigate();
  const { customer } = useAppSelector((state) => state.customer);

  const handleNavigation = () => {
    if (cartMode === "pickup") navigate(`/pos/customer/${customerId}/history`);
    else navigate(`/pos/${customerId}`);
  };

  const handleOpenPdf = (report: ICustomerGeneratedReport) => {
    setSelectedReportData(report);
    setSelectedReport(report.reportTitle);
    dispatch(CustomerSliceAction.clearCustomerReportData());
    setOpenPdfModal(true);
    if (customerId) {
      dispatch(getCustomerReportDataAction({
        customerId: Number(customerId),
        reportType: report.reportType,
        periodStart: report.periodStart ? new Date(report.periodStart) : null,
        periodEnd: report.periodEnd ? new Date(report.periodEnd) : null,
      }));
    }
  };

  const invoiceToReportData = (inv: IMonthlyInvoice): ICustomerGeneratedReport => ({
    id: inv.id,
    customerId: inv.customerId,
    reportType: "Monthly Invoice",
    reportTitle: `Monthly Invoice — ${new Date(inv.invoiceYear, inv.invoiceMonth - 1, 1).toLocaleString("en-US", { month: "long" })} ${inv.invoiceYear}`,
    periodStart: new Date(inv.invoiceYear, inv.invoiceMonth - 1, 1).toISOString(),
    periodEnd: new Date(inv.invoiceYear, inv.invoiceMonth, 0, 23, 59, 59).toISOString(),
    totalAmount: inv.totalAmount,
    totalOrders: inv.orderCount,
    generatedAt: inv.generatedAt,
  });

  const formatReportPeriod = (report: ICustomerGeneratedReport): string => {
    const type = report.reportType.toLowerCase();
    if (type.includes("annual") && report.periodStart)
      return String(new Date(report.periodStart).getFullYear());
    if ((type.includes("monthly") || type.includes("invoice")) && report.periodStart) {
      const d = new Date(report.periodStart);
      return d.toLocaleString("en-US", { month: "long" }) + " " + d.getFullYear();
    }
    if (report.periodStart && report.periodEnd)
      return new Date(report.periodStart).toLocaleDateString("en-US") + " – " + new Date(report.periodEnd).toLocaleDateString("en-US");
    return report.periodStart ? new Date(report.periodStart).toLocaleDateString("en-US") : "—";
  };

  const pdfCustomerName = `${customer?.firstName ?? ""} ${customer?.lastName ?? ""}`.trim() || "—";
  const pdfCustomerId = customer?.id ? `CUST-${customer.id}` : "—";
  const pdfAddress = [customer?.personalAddressLine1, customer?.personalAddressLine2, customer?.personalCity, customer?.personalState, customer?.personalZip].filter(Boolean).join(", ") || "—";
  const pdfContact = customer?.mobilePhone || customer?.landPhone || "—";

  const getPeriodDates = (): { periodStart: Date | null; periodEnd: Date | null } => {
    const isAnnual = selectedReportType.toLowerCase().includes("annual");
    const isMonthly = selectedReportType.toLowerCase().includes("monthly");
    if (isAnnual && startDate) {
      const s = new Date(startDate.getFullYear(), 0, 1);
      const e = new Date(startDate.getFullYear(), 11, 31, 23, 59, 59);
      return { periodStart: s, periodEnd: e };
    }
    if (isMonthly && startDate) {
      const s = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      const e = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0, 23, 59, 59);
      return { periodStart: s, periodEnd: e };
    }
    return { periodStart: dateRange?.from ?? null, periodEnd: dateRange?.to ?? null };
  };

  const filteredBills = useMemo(() =>
    reportBills.filter((b) =>
      !ticketSearch || b.billId?.toLowerCase().includes(ticketSearch.toLowerCase())
    ), [reportBills, ticketSearch]);

  const allSelected = filteredBills.length > 0 && filteredBills.every((b) => selectedBillIds.has(b.id));

  const toggleBill = (id: number) => {
    setSelectedBillIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleAll = () => {
    if (allSelected) {
      setSelectedBillIds((prev) => {
        const next = new Set(prev);
        filteredBills.forEach((b) => next.delete(b.id));
        return next;
      });
    } else {
      setSelectedBillIds((prev) => {
        const next = new Set(prev);
        filteredBills.forEach((b) => next.add(b.id));
        return next;
      });
    }
  };

  const handleAddTicket = async () => {
    if (showInvoicePanel) { setShowInvoicePanel(false); return; }
    const { periodStart, periodEnd } = getPeriodDates();
    if (!customerId || !periodStart || !periodEnd) {
      Snackbar.showSnackbar("Please select a date first", "error"); return;
    }
    setLoadingBills(true);
    setShowInvoicePanel(true);
    try {
      const params = new URLSearchParams({
        size: "500", page: "0", filterDateType: "DATE_IN",
        startDate: dayjs(periodStart).format("YYYY-MM-DD"),
        endDate: dayjs(periodEnd).format("YYYY-MM-DD"),
      });
      const res = await axios.get(`${BASE_URL}/bill/customer/${customerId}?${params.toString()}`);
      const bills: ICustomerBill[] = res.data?.body?.content ?? [];
      setReportBills(bills);
      setSelectedBillIds(new Set(bills.map((b) => b.id)));
    } catch {
      Snackbar.showSnackbar("Failed to load invoices", "error");
    } finally {
      setLoadingBills(false);
    }
  };

  const handleGenerateReport = async () => {
    if (!customerId) return;
    const { periodStart, periodEnd } = getPeriodDates();
    const result = await dispatch(generateCustomerReportAction({
      customerId: Number(customerId),
      reportType: selectedReportType,
      periodStart,
      periodEnd,
      ...(reportBills.length > 0 ? { billIds: Array.from(selectedBillIds) } : {}),
    }));
    if (generateCustomerReportAction.fulfilled.match(result)) {
      const report = result.payload;
      if (report) {
        setSelectedReportData(report);
        setSelectedReport(report.reportTitle);
        dispatch(CustomerSliceAction.clearCustomerReportData());
        setOpenPdfModal(true);
        dispatch(getCustomerReportDataAction({
          customerId: Number(customerId),
          reportType: report.reportType,
          periodStart: report.periodStart ? new Date(report.periodStart) : null,
          periodEnd: report.periodEnd ? new Date(report.periodEnd) : null,
          ...(reportBills.length > 0 ? { billIds: Array.from(selectedBillIds) } : {}),
        }));
      }
    } else {
      Snackbar.showSnackbar("Failed to generate report", "error");
    }
  };

  const handleDownload = async () => {
    const blob = await pdf(
      <ExpenditureReport
        name={pdfCustomerName}
        customerId={pdfCustomerId}
        address={pdfAddress}
        contactNumber={pdfContact}
        total={selectedReportData?.totalAmount ?? 0}
        month={selectedReportData ? formatReportPeriod(selectedReportData) : "—"}
        reportTitle={selectedReportData?.reportTitle}
        notes={reportNotes}
      />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${selectedReportData?.reportTitle ?? "Report"}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handlePrint = async () => {
    const blob = await pdf(
      <ExpenditureReport
        name={pdfCustomerName}
        customerId={pdfCustomerId}
        address={pdfAddress}
        contactNumber={pdfContact}
        total={selectedReportData?.totalAmount ?? 0}
        month={selectedReportData ? formatReportPeriod(selectedReportData) : "—"}
        reportTitle={selectedReportData?.reportTitle}
        notes={reportNotes}
      />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => { iframe.contentWindow?.print(); URL.revokeObjectURL(url); };
  };

  // ── derived data ────────────────────────────────────────────────────────────
  const currentYearItems = useMemo(() =>
    (customerCurrentYearServiceUsage ?? []).map((s, i) => ({
      label: s.serviceName, value: s.count, color: SERVICE_COLORS[i % SERVICE_COLORS.length],
    })), [customerCurrentYearServiceUsage]);

  const allTimeItems = useMemo(() =>
    (customerAllTimeServiceUsage ?? []).map((s, i) => ({
      label: s.serviceName, value: s.count, color: SERVICE_COLORS[i % SERVICE_COLORS.length],
    })), [customerAllTimeServiceUsage]);

  const flatRefunds = useMemo(() => {
    if (!customerRefundHistory?.refundsByDate) return [];
    let idx = 1;
    return customerRefundHistory.refundsByDate.flatMap((group) =>
      group.refunds.map((r) => ({
        no: String(idx++).padStart(2, "0"),
        date: new Date(group.refundDate).toLocaleDateString("en-US"),
        amount: r.refundTotal ?? 0,
        requestedBy: r.cashierId != null ? `CSH${r.cashierId}` : "—",
        approvedBy: r.managerId != null ? `MN${r.managerId}` : "—",
        reason: r.reason ?? "—",
        raw: r,
      }))
    );
  }, [customerRefundHistory]);

  const filteredRefunds = useMemo(() => {
    return flatRefunds.filter((row) => {
      const q = searchQuery.toLowerCase();
      const matchSearch = !q || row.requestedBy.toLowerCase().includes(q) || row.approvedBy.toLowerCase().includes(q) || row.reason.toLowerCase().includes(q) || row.date.includes(q);
      const rowDate = new Date(row.date);
      const matchDate = !selectedDate || rowDate.toDateString() === selectedDate.toDateString();
      return matchSearch && matchDate;
    });
  }, [flatRefunds, searchQuery, selectedDate]);

  const largestRefund = flatRefunds.reduce((m, r) => r.amount > m ? r.amount : m, 0);
  const avgRefund = flatRefunds.length ? flatRefunds.reduce((s, r) => s + r.amount, 0) / flatRefunds.length : 0;

  return (
    <PosLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          minHeight: 0,
          overflow: "hidden",
          gap: "0.57rem",
        }}
      >
        <Box
          sx={{
            flex: 4,
            display: "flex",
            flexDirection: "column",
            gap: "1.78rem",
            height: "100%",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <CustomerDetailSection
            showAnalysisButton={false}
            showEditButton={true}
            showHistoryButton={true}
          />
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              borderRadius: "1.75rem",
              border: `1px solid ${Colors.ACCENT_GRAY}`,
              background: Colors.WHITE,
              padding: "1.25rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              overflowY: "auto",
              boxShadow: "0 18px 50px rgba(0,0,0,0.08)",
            }}
          >
            {/* Header */}
            <Box sx={{ flexShrink: 0, display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem" }}>
              <Box>
                {/* --fs-lg (1.8rem) — matches app's 1.875rem page title convention */}
                <Typography sx={{ fontSize: "var(--fs-lg)", fontWeight: "bold", color: Colors.TEXT_GRAY_DARK, lineHeight: 1 }}>
                  Customer Insights
                </Typography>
                {/* --fs-2xs (1.0rem) — matches app's 0.875rem subtitle convention */}
                <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-2xs)", color: `${Colors.TEXT_GRAY_DARK}BF` }}>
                  Activity, visits, and spend summary
                </Typography>
              </Box>
              {/* --fs-2xs (1.0rem) — matches app's 0.875rem badge/chip convention */}
              <Box sx={{ borderRadius: "999px", border: `1px solid ${Colors.PRIMARY}33`, background: `${Colors.PRIMARY}1A`, px: "0.85rem", py: "0.35rem", fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.PRIMARY, whiteSpace: "nowrap" }}>
                Active Customer
              </Box>
            </Box>

            {/* Row 1 — Customer Since + Spend Summary (2:3 grid) */}
            <Box sx={{ flexShrink: 0, display: "grid", gridTemplateColumns: "2fr 3fr", gap: "0.75rem" }}>
              {/* Customer Since card */}
              <Box sx={{ borderRadius: "1.25rem", border: `1px solid ${Colors.ACCENT_GRAY}`, background: "linear-gradient(135deg, #F7F7F7, #E6E6E6)", p: "1rem", display: "flex", flexDirection: "column" }}>
                {/* --fs-2xs (1.0rem) — matches app's 0.875rem label convention */}
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: `${Colors.TEXT_GRAY_DARK}B3` }}>
                  Customer Since
                </Typography>
                {/* --fs-3xl ≈ text-[28px] — hero date value (figure, unchanged) */}
                <Typography sx={{ mt: "0.35rem", fontSize: "var(--fs-3xl)", fontWeight: "bold", color: Colors.TEXT_GRAY_DARK, lineHeight: 1 }}>
                  {customerInsights?.creationMonthYear || "N/A"}
                </Typography>
                <Box sx={{ mt: "0.6rem", borderRadius: "0.85rem", border: "1px solid rgba(255,255,255,0.8)", background: "rgba(255,255,255,0.7)", p: "0.75rem" }}>
                  <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: `${Colors.TEXT_GRAY_DARK}B3` }}>
                    Last Visit
                  </Typography>
                  {/* --fs-2xl ≈ text-[22px] — prominent date (figure, unchanged) */}
                  <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-2xl)", fontWeight: "bold", color: Colors.SECONDARY, lineHeight: 1 }}>
                    {customerLatestBillDetails?.createdDate
                      ? formatUSDate(new Date(customerLatestBillDetails.createdDate))
                      : "N/A"}
                  </Typography>
                </Box>
              </Box>

              {/* Spend Summary — blue-to-green gradient */}
              <Box sx={{ borderRadius: "1.25rem", background: `linear-gradient(135deg, ${Colors.SECONDARY}, ${Colors.PRIMARY})`, p: "1rem", color: Colors.WHITE, display: "flex", flexDirection: "column" }}>
                {/* --fs-2xs — section label, matches app convention */}
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.8)" }}>
                  Spend Summary
                </Typography>
                <Box sx={{ mt: "0.6rem", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}>
                  <Box>
                    {/* --fs-2xs — field label, matches app's 0.625rem convention */}
                    <Typography sx={{ fontSize: "var(--fs-2xs)", color: "rgba(255,255,255,0.8)" }}>Current Year</Typography>
                    {/* --fs-4xl ≈ text-[34px] — hero spend number (figure, unchanged) */}
                    <Typography sx={{ mt: "0.28rem", fontSize: "var(--fs-4xl)", fontWeight: "bold", lineHeight: 1 }}>
                      {customerInsights?.currentYearBillAmount !== undefined
                        ? formatCurrency({ amount: customerInsights.currentYearBillAmount, prefix: "$" })
                        : "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ borderLeft: "1px solid rgba(255,255,255,0.25)", pl: "0.75rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", color: "rgba(255,255,255,0.8)" }}>Lifetime</Typography>
                    <Typography sx={{ mt: "0.28rem", fontSize: "var(--fs-4xl)", fontWeight: "bold", lineHeight: 1 }}>
                      {customerInsights?.totalBillAmount !== undefined
                        ? formatCurrency({ amount: customerInsights.totalBillAmount, prefix: "$" })
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ mt: "0.6rem", borderRadius: "0.85rem", background: "rgba(255,255,255,0.15)", px: "0.75rem", py: "0.6rem" }}>
                  <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.8)" }}>
                    Orders Summary
                  </Typography>
                  <Box sx={{ mt: "0.5rem", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}>
                    <Box>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: "rgba(255,255,255,0.8)" }}>Current Year</Typography>
                      {/* --fs-2xl ≈ text-2xl (24px) — metric count (figure, unchanged) */}
                      <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1 }}>
                        {customerInsights?.currentYearBillCount !== undefined
                          ? String(customerInsights.currentYearBillCount)
                          : "N/A"}
                      </Typography>
                    </Box>
                    <Box sx={{ borderLeft: "1px solid rgba(255,255,255,0.25)", pl: "0.75rem" }}>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: "rgba(255,255,255,0.8)" }}>Lifetime</Typography>
                      <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1 }}>
                        {customerInsights?.totalBillCount !== undefined
                          ? String(customerInsights.totalBillCount)
                          : "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Row 2 — Metric Pills (Last Payment | Last Visit Orders | Total Visits) */}
            <Box sx={{ flexShrink: 0, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.6rem" }}>
              {/* Last Payment — blue */}
              <Box sx={{ borderRadius: "1.25rem", border: "1px solid transparent", background: Colors.SECONDARY, p: "0.85rem", boxShadow: "0 0.5rem 1.25rem rgba(0,0,0,0.08)", display: "flex", flexDirection: "column" }}>
                {/* --fs-2xs — pill label, consistent with app label convention */}
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "rgba(255,255,255,0.8)" }}>
                  Last Payment
                </Typography>
                {/* --fs-2xl ≈ text-2xl (24px) — pill value (figure, unchanged) */}
                <Typography sx={{ mt: "auto", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1, color: Colors.WHITE }}>
                  {customerLatestBillDetails?.paymentAmount === null
                    ? "—"
                    : customerLatestBillDetails?.paymentAmount !== undefined
                    ? formatCurrency({ amount: customerLatestBillDetails.paymentAmount, prefix: "$" })
                    : "N/A"}
                </Typography>
              </Box>

              {/* Last Visit Orders — blue with drop-off / pick-up sub-grid */}
              <Box sx={{ borderRadius: "1.25rem", border: "1px solid transparent", background: Colors.SECONDARY, p: "0.85rem", boxShadow: "0 0.5rem 1.25rem rgba(0,0,0,0.08)" }}>
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "rgba(255,255,255,0.8)" }}>
                  Last Visit Orders
                </Typography>
                <Box sx={{ mt: "0.6rem", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.4rem" }}>
                  <Box sx={{ borderRadius: "0.65rem", background: "rgba(255,255,255,0.15)", px: "0.6rem", py: "0.5rem" }}>
                    {/* --fs-2xs — tiny sub-label inside a pill */}
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "rgba(255,255,255,0.7)" }}>
                      Drop Off
                    </Typography>
                    {/* --fs-2xl ≈ text-2xl (24px) — sub-cell count (figure, unchanged) */}
                    <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1, color: Colors.WHITE }}>
                      {customerLatestBillDetails?.numberOfBillItems !== undefined
                        ? String(customerLatestBillDetails.numberOfBillItems)
                        : "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ borderRadius: "0.65rem", background: "rgba(255,255,255,0.15)", px: "0.6rem", py: "0.5rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "rgba(255,255,255,0.7)" }}>
                      Pick Up
                    </Typography>
                    <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1, color: Colors.WHITE }}>
                      0
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Total Visits — green */}
              <Box sx={{ borderRadius: "1.25rem", border: "1px solid transparent", background: Colors.PRIMARY, p: "0.85rem", boxShadow: "0 0.5rem 1.25rem rgba(0,0,0,0.08)", display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "rgba(255,255,255,0.8)" }}>
                  Total Visits
                </Typography>
                <Typography sx={{ mt: "auto", fontSize: "var(--fs-2xl)", fontWeight: "bold", lineHeight: 1, color: Colors.WHITE }}>
                  {customerInsights?.totalVisitCount !== undefined ? String(customerInsights.totalVisitCount) : "N/A"}
                </Typography>
              </Box>
            </Box>

            {/* Row 3 — Average Value (Weekly, Monthly, Yearly) */}
            <Box sx={{ flexShrink: 0, borderRadius: "1.25rem", border: `1px solid ${Colors.ACCENT_GRAY}`, background: Colors.WHITE, px: "0.85rem", py: "0.6rem", display: "flex", flexDirection: "column" }}>
              {/* --fs-xs (1.2rem) — slightly above body label, consistent with 0.875rem bold section titles */}
              <Typography sx={{ flexShrink: 0, fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.TEXT_GRAY_DARK, mb: "0.4rem" }}>
                Average Value
              </Typography>
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.6rem", mt: "0.35rem" }}>
                {[
                  { label: "Weekly Avg",  value: customerAvgSpendings?.weeklyAverageSpending },
                  { label: "Monthly Avg", value: customerAvgSpendings?.monthlyAverageSpending },
                  { label: "Yearly Avg",  value: customerAvgSpendings?.yearlyAverageSpending },
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ borderRadius: "0.85rem", border: `1px solid ${Colors.ACCENT_GRAY}`, background: "#F7F7F7", px: "0.65rem", py: "0.5rem", display: "flex", flexDirection: "column" }}>
                    {/* --fs-2xs — card label, matches app's 0.75rem convention */}
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: `${Colors.TEXT_GRAY_DARK}B3` }}>
                      {label}
                    </Typography>
                    {/* --fs-xl ≈ text-xl (20px) — card value (figure, unchanged) */}
                    <Typography sx={{ mt: "0.2rem", fontSize: "var(--fs-xl)", fontWeight: "bold", color: Colors.TEXT_GRAY_DARK, lineHeight: 1 }}>
                      {value !== undefined ? formatCurrency({ amount: value, prefix: "$" }) : "N/A"}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: "0.14rem", background: Colors.ACCENT_GRAY }} />
        <Box sx={{ flex: 5, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", position: "relative", gap: "0.75rem" }}>
          <TopRightButton variation="Back" onClick={handleNavigation} />

          {/* ── Title ──────────────────────────────────────────────────── */}
          <Box sx={{ flexShrink: 0, pr: "3rem" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "var(--fs-lg)", color: Colors.MAIN_GRAY, lineHeight: 1 }}>
              Customer Analysis Reports
            </Typography>
            <Typography sx={{ mt: "0.25rem", fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}A6` }}>
              Financial, usage, and pickup behavior insights
            </Typography>
          </Box>

          {/* ── Pill Tabs ───────────────────────────────────────────────── */}
          <Box sx={{ flexShrink: 0, display: "flex", borderRadius: "1rem", border: `1px solid ${Colors.ACCENT_GRAY}`, background: Colors.WHITE, p: "0.25rem", gap: "0.25rem" }}>
            {([{ i: 0, l: "Analysis" }, { i: 1, l: "Patterns" }, { i: 2, l: "Reports" }, { i: 3, l: "Refunds & Claims" }] as const).map(({ i, l }) => (
              <Box key={i} component="button"
                onClick={() => i === 2 ? handleReportsTab() : setSelectedTab(i)}
                sx={{ flex: 1, borderRadius: "0.75rem", py: "0.75rem", fontSize: "var(--fs-2xs)", fontWeight: "bold", border: "none", cursor: "pointer", transition: "all 0.15s", background: selectedTab === i ? Colors.PRIMARY : "transparent", color: selectedTab === i ? Colors.WHITE : Colors.PRIMARY, "&:hover": selectedTab !== i ? { background: `${Colors.PRIMARY}1A` } : {} }}>
                {l}
              </Box>
            ))}
          </Box>

          {/* ── Tab Content ─────────────────────────────────────────────── */}
          <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column", background: Colors.BACKSHADE_GRAY, borderRadius: "1rem" }}>

            {selectedTab === 0 && (
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: "0.75rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                  <StatCard label="Total Outstanding" value={formatCurrency({ amount: customerOutstanding?.outstandingAmount ?? 0, prefix: "$" })} helper={(customerOutstanding?.outstandingAmount ?? 0) > 0 ? "Balance due" : "No balance due"} tone={(customerOutstanding?.outstandingAmount ?? 0) > 0 ? "red" : undefined} Icon={DollarSvg} />
                  <StatCard label="Store Credit Amount" value={formatCurrency({ amount: customer?.storeCreditBalance ?? 0, prefix: "$" })} helper={(customer?.storeCreditBalance ?? 0) > 0 ? "Available credit" : "No credit available"} tone={(customer?.storeCreditBalance ?? 0) > 0 ? "green" : undefined} Icon={CreditCardSvg} />
                </Box>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                  <UsageCard title="Current Year Service Usage" items={currentYearItems} totalCount={currentYearItems.reduce((s, i) => s + i.value, 0)} totalSpend={formatCurrency({ amount: customerInsights?.currentYearBillAmount ?? 0, prefix: "$" })} />
                  <UsageCard title="All Time Service Usage" items={allTimeItems} totalCount={customerInsights?.totalBillItemCount ?? 0} totalSpend={formatCurrency({ amount: customerInsights?.totalBillAmount ?? 0, prefix: "$" })} />
                </Box>
              </Box>
            )}

            {selectedTab === 1 && (
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: "0.75rem" }}>
                <PatternsTab activitiesByDay={customerActivitiesByDay} topServiceName={currentYearItems[0]?.label} totalBillItemCount={customerInsights?.totalBillItemCount} />
              </Box>
            )}

            {selectedTab === 2 && (
              <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", gap: "0.75rem", p: "0.75rem" }}>
                {/* Filter row */}
                <Box sx={{ flexShrink: 0, display: "grid", gridTemplateColumns: "minmax(10.625rem,1fr) minmax(14.375rem,1.4fr) 2.25rem 7.5rem 7.5rem", gap: "0.75rem", alignItems: "flex-end", borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>Report Type</Typography>
                    <TextField select size="small" fullWidth value={selectedReportType} onChange={(e) => setSelectedReportType(e.target.value)} sx={{ background: Colors.WHITE, borderRadius: "0.5rem" }}>
                      {reportTypes.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                    </TextField>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>
                      {selectedReportType.includes("Annual") ? "Select Year" : selectedReportType.includes("Monthly") ? "Select Month" : "Date Range"}
                    </Typography>
                    {selectedReportType.includes("Annual") ? (
                      <CustomDateTimePicker type="date" view="year" enableSelect="past" value={startDate ? dayjs(startDate) : null} onChange={(d) => setDateRange(d?.toDate() ? { from: d.toDate(), to: undefined } : undefined)} />
                    ) : selectedReportType.includes("Monthly") ? (
                      <CustomDateTimePicker type="date" view="month" enableSelect="past" value={startDate ? dayjs(startDate) : null} onChange={(d) => setDateRange(d?.toDate() ? { from: d.toDate(), to: undefined } : undefined)} />
                    ) : (
                      <Box sx={{ border: `1px solid ${Colors.ACCENT_GRAY}`, borderRadius: "0.25rem" }}>
                        <DatePicker type="range" value={dateRange} onChange={(val) => setDateRange(val as DateRange)} minDate={new Date("2021-01-01")} maxDate={new Date()} compact />
                      </Box>
                    )}
                  </Box>
                  {/* Notes pen icon */}
                  <Box
                    component="button"
                    title={reportNotes ? "Edit notes" : "Add notes"}
                    onClick={() => setShowAddNote(true)}
                    sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "2.25rem", height: "2.25rem", borderRadius: "0.5rem", border: `1px solid ${reportNotes ? Colors.PRIMARY : Colors.ACCENT_GRAY}`, color: reportNotes ? Colors.PRIMARY : `${Colors.MAIN_GRAY}99`, background: reportNotes ? `${Colors.PRIMARY}1A` : Colors.WHITE, cursor: "pointer", "&:hover": { border: `1px solid ${Colors.PRIMARY}`, color: Colors.PRIMARY, background: `${Colors.PRIMARY}1A` } }}>
                    <PenSvg />
                  </Box>

                  <Box
                    component="button"
                    onClick={handleAddTicket}
                    sx={{ borderRadius: "0.5rem", border: `1px solid ${showInvoicePanel ? Colors.PRIMARY : Colors.ACCENT_GRAY}`, background: showInvoicePanel ? `${Colors.PRIMARY}1A` : Colors.WHITE, color: showInvoicePanel ? Colors.PRIMARY : Colors.MAIN_GRAY, fontWeight: "bold", fontSize: "var(--fs-2xs)", cursor: "pointer", py: "0.5rem", "&:hover": { border: `1px solid ${Colors.PRIMARY}`, color: Colors.PRIMARY, background: `${Colors.PRIMARY}1A` } }}>
                    Add Ticket
                  </Box>

                  <Box
                    component="button"
                    onClick={handleGenerateReport}
                    sx={{ borderRadius: "0.5rem", background: generateReportLoading ? `${Colors.PRIMARY}99` : Colors.PRIMARY, color: Colors.WHITE, fontWeight: "bold", fontSize: "var(--fs-2xs)", border: "none", cursor: generateReportLoading ? "not-allowed" : "pointer", py: "0.5rem", "&:hover": { background: generateReportLoading ? `${Colors.PRIMARY}99` : Colors.PRIMARY_DARK } }}>
                    {generateReportLoading ? "Saving..." : "Generate"}
                  </Box>
                </Box>

                {/* Invoice selection panel */}
                {showInvoicePanel && (
                  <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
                    {/* Panel header */}
                    <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", mb: "0.75rem" }}>
                      <Typography sx={{ fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>
                        Select Invoices
                      </Typography>
                      <TextField
                        size="small"
                        placeholder="Ticket No."
                        value={ticketSearch}
                        onChange={(e) => setTicketSearch(e.target.value)}
                        InputProps={{ endAdornment: <InputAdornment position="end"><Search sx={{ fontSize: "1rem" }} /></InputAdornment> }}
                        sx={{ width: "10rem", "& .MuiInputBase-input": { fontSize: "var(--fs-2xs)", py: "0.375rem" } }}
                      />
                    </Box>

                    {/* Table */}
                    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", border: `1px solid ${Colors.ACCENT_GRAY}`, borderRadius: "0.5rem", overflow: "hidden" }}>
                      {/* Header */}
                      <Box sx={{ flexShrink: 0, display: "grid", gridTemplateColumns: "1.75rem 1fr 1fr 1fr 1fr 1fr", gap: "0.5rem", background: Colors.SECONDARY, px: "0.75rem", py: "0.5rem" }}>
                        {["", "Ticket Number", "Date In", "Cashier", "Pieces", "Balance"].map((h) => (
                          <Typography key={h} sx={{ fontSize: "var(--fs-2xs)", fontWeight: "bold", color: Colors.WHITE }}>{h}</Typography>
                        ))}
                      </Box>

                      {/* Rows */}
                      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
                        {loadingBills ? (
                          <Box sx={{ py: "1.5rem", textAlign: "center" }}>
                            <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80` }}>Loading invoices...</Typography>
                          </Box>
                        ) : filteredBills.length > 0 ? (
                          filteredBills.map((bill) => (
                            <Box key={bill.id} sx={{ display: "grid", gridTemplateColumns: "1.75rem 1fr 1fr 1fr 1fr 1fr", gap: "0.5rem", px: "0.75rem", py: "0.45rem", borderBottom: `1px solid ${Colors.ACCENT_GRAY}`, alignItems: "center", background: selectedBillIds.has(bill.id) ? `${Colors.PRIMARY}08` : Colors.WHITE }}>
                              <Box
                                component="input"
                                type="checkbox"
                                checked={selectedBillIds.has(bill.id)}
                                onChange={() => toggleBill(bill.id)}
                                sx={{ cursor: "pointer", accentColor: Colors.PRIMARY, width: "0.875rem", height: "0.875rem", margin: 0 }}
                              />
                              <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>{bill.billId || "—"}</Typography>
                              <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>
                                {bill.createdTime ? new Date(bill.createdTime).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }) : "—"}
                              </Typography>
                              <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>{bill.cashierId || "—"}</Typography>
                              <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>{bill.totalPieceCount ?? 0}</Typography>
                              <Typography sx={{ fontSize: "var(--fs-2xs)", color: Colors.MAIN_GRAY }}>{bill.billAmount?.toFixed(2) ?? "0.00"}</Typography>
                            </Box>
                          ))
                        ) : (
                          <Box sx={{ py: "1.5rem", textAlign: "center" }}>
                            <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80` }}>No invoices found for this period.</Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>

                    {/* Footer */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: "0.6rem" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <Box
                          component="input"
                          type="checkbox"
                          checked={allSelected}
                          onChange={toggleAll}
                          sx={{ cursor: "pointer", accentColor: Colors.PRIMARY, width: "0.875rem", height: "0.875rem", margin: 0 }}
                        />
                        <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>
                          Select All
                        </Typography>
                        {reportBills.length > 0 && (
                          <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80` }}>
                            ({selectedBillIds.size}/{reportBills.length} selected)
                          </Typography>
                        )}
                      </Box>
                      <Box
                        component="button"
                        onClick={() => setShowInvoicePanel(false)}
                        sx={{ borderRadius: "0.5rem", background: Colors.PRIMARY, color: Colors.WHITE, fontWeight: "bold", fontSize: "var(--fs-2xs)", border: "none", cursor: "pointer", px: "1.5rem", py: "0.45rem", "&:hover": { background: Colors.PRIMARY_DARK } }}>
                        Done
                      </Box>
                    </Box>
                  </Box>
                )}

                {/* Generated Reports list */}
                {!showInvoicePanel && <Box sx={{ flexShrink: 0 }}>
                  <Typography sx={{ mb: "0.5rem", fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>
                    Generated Reports {customerGeneratedReports ? `(${customerGeneratedReports.length})` : ""}
                  </Typography>
                  <Box sx={{ height: "10rem", overflowY: "auto", borderRadius: "0.75rem", background: Colors.WHITE, p: "0.5rem" }}>
                    {customerGeneratedReports && customerGeneratedReports.length > 0 ? (
                      customerGeneratedReports.map((r) => (
                        <ReportRow
                          key={r.id}
                          name={r.reportTitle}
                          showDocButton
                          onView={() => handleOpenPdf(r)}
                          onEmail={() => { setSelectedReportData(r); setDownloadAccessOpen(true); }}
                          onPrint={() => { setSelectedReportData(r); setPrintAccessOpen(true); }}
                        />
                      ))
                    ) : (
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80`, py: "0.5rem", px: "0.25rem" }}>
                        Select a report type and click Generate to create a report.
                      </Typography>
                    )}
                  </Box>
                </Box>}

                {/* Invoice History — monthly charge customers only */}
                {!showInvoicePanel && <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                  <Typography sx={{ mb: "0.5rem", flexShrink: 0, fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>
                    Invoice History {isMonthlyCustomer && customerMonthlyInvoices ? `(${customerMonthlyInvoices.length})` : ""}
                  </Typography>
                  <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", borderRadius: "0.75rem", background: Colors.WHITE, p: "0.5rem" }}>
                    {isMonthlyCustomer === null ? (
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80`, py: "0.5rem", px: "0.25rem" }}>Loading...</Typography>
                    ) : !isMonthlyCustomer ? (
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "0.5rem" }}>
                        <Typography sx={{ fontSize: "var(--fs-xs)", fontWeight: "bold", color: `${Colors.MAIN_GRAY}80` }}>Not a Monthly Charge Customer</Typography>
                        <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}60`, textAlign: "center" }}>
                          Invoice history is generated automatically on the 1st of each month for monthly charge customers only.
                        </Typography>
                      </Box>
                    ) : customerMonthlyInvoices && customerMonthlyInvoices.length > 0 ? (
                      customerMonthlyInvoices.map((inv) => {
                        const monthName = new Date(inv.invoiceYear, inv.invoiceMonth - 1, 1).toLocaleString("en-US", { month: "long" });
                        const name = `${inv.invoiceNumber} — ${monthName} ${inv.invoiceYear} — $${inv.totalAmount?.toFixed(2) ?? "0.00"} (${inv.orderCount ?? 0} orders)`;
                        return (
                          <ReportRow
                            key={inv.id}
                            name={name}
                            onView={() => handleOpenPdf(invoiceToReportData(inv))}
                            onEmail={() => { setSelectedReportData(invoiceToReportData(inv)); setDownloadAccessOpen(true); }}
                            onPrint={() => { setSelectedReportData(invoiceToReportData(inv)); setPrintAccessOpen(true); }}
                          />
                        );
                      })
                    ) : (
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}80`, py: "0.5rem", px: "0.25rem" }}>
                        No monthly invoices generated yet. Invoices are created automatically on the 1st of each month.
                      </Typography>
                    )}
                  </Box>
                </Box>}
              </Box>
            )}

            {selectedTab === 3 && (
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: "0.75rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                  <SplitTotalCard title="Total Claims" currentValue={customerRefundStatsByYear?.totalRefundAmount ?? 0} lifetimeValue={customerRefundStats?.totalRefundAmount ?? 0} currentHelper={`${customerRefundStatsByYear?.refundedBillsCount ?? 0} claims`} lifetimeHelper="All-time claims" tone="red" />
                  <SplitTotalCard title="Total Refunds" currentValue={customerRefundStatsByYear?.totalRefundAmount ?? 0} lifetimeValue={customerRefundStats?.totalRefundAmount ?? 0} currentHelper={`${flatRefunds.length} refunds`} lifetimeHelper="All-time refunds" tone="blue" />
                </Box>
                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "1rem" }}>
                  <InsightCard label="Largest Claim" value={`$${largestRefund.toFixed(2)}`} helper="Highest single refund" tone="red" />
                  <InsightCard label="Average Claim" value={`$${avgRefund.toFixed(2)}`} helper="Per refund average" />
                  <InsightCard label="Total Refunds" value={String(flatRefunds.length)} helper={`${customerRefundStats?.refundedBillsCount ?? 0} bills affected`} tone="blue" />
                </Box>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 6rem", gap: "0.75rem", alignItems: "flex-end", borderRadius: "1rem", background: Colors.WHITE, p: "1rem", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>Date of Claim</Typography>
                    <Box sx={{ border: `1px solid ${Colors.ACCENT_GRAY}`, borderRadius: "0.25rem" }}>
                      <DatePicker type="single" value={selectedDate ?? undefined} onChange={(v) => setSelectedDate(v instanceof Date ? v : null)} compact />
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                    <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: `${Colors.MAIN_GRAY}B3` }}>Search</Typography>
                    <TextField size="small" placeholder="Search reason, cashier, manager..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end"><Search /></InputAdornment> }} />
                  </Box>
                  <Box component="button" sx={{ borderRadius: "0.5rem", background: Colors.PRIMARY, color: Colors.WHITE, fontWeight: "bold", fontSize: "var(--fs-2xs)", border: "none", cursor: "pointer", py: "0.5rem", "&:hover": { background: Colors.PRIMARY_DARK } }}>
                    Search
                  </Box>
                </Box>
                <Box sx={{ borderRadius: "1rem", background: Colors.WHITE, overflow: "hidden", boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.08)" }}>
                  <Box sx={{ display: "grid", gridTemplateColumns: "2.75rem 5.75rem 5.625rem 5.625rem 5.625rem 1fr 4.5rem", background: Colors.SECONDARY, px: "0.75rem", py: "0.75rem", gap: "0.5rem" }}>
                    {["No.", "Date", "Amount", "Requested By", "Approved By", "Reason", "Action"].map((h) => (
                      <Typography key={h} sx={{ fontSize: "var(--fs-2xs)", fontWeight: "bold", color: Colors.WHITE }}>{h}</Typography>
                    ))}
                  </Box>
                  {filteredRefunds.length > 0 ? filteredRefunds.map((row) => (
                    <Box key={row.no} sx={{ display: "grid", gridTemplateColumns: "2.75rem 5.75rem 5.625rem 5.625rem 5.625rem 1fr 4.5rem", alignItems: "center", borderBottom: `1px solid ${Colors.WHITE}`, background: `${Colors.ACCENT_GRAY}B3`, px: "0.75rem", py: "0.75rem", gap: "0.5rem" }}>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{row.no}</Typography>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{row.date}</Typography>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>${row.amount.toFixed(2)}</Typography>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{row.requestedBy}</Typography>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{row.approvedBy}</Typography>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.reason}</Typography>
                      <Box component="button" onClick={() => setSelectedRefundRow(row)} sx={{ borderRadius: "0.5rem", background: Colors.SECONDARY, color: Colors.WHITE, fontWeight: "bold", fontSize: "var(--fs-2xs)", border: "none", cursor: "pointer", px: "0.75rem", py: "0.375rem" }}>View</Box>
                    </Box>
                  )) : (
                    <Box sx={{ textAlign: "center", py: "2rem" }}>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", color: `${Colors.MAIN_GRAY}99` }}>No refunds found</Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}

          </Box>

          {/* Refund detail modal */}
          {selectedRefundRow && (
            <Box sx={{ position: "fixed", inset: 0, zIndex: 1300, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.35)", p: "1rem" }}>
              <Box sx={{ width: "100%", maxWidth: "35.625rem", borderRadius: "1.5rem", background: Colors.WHITE, p: "1.5rem", boxShadow: "0 1.5rem 3rem rgba(0,0,0,0.2)" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "1.25rem" }}>
                  <Typography sx={{ fontSize: "var(--fs-xs)", fontWeight: "bold", color: Colors.MAIN_GRAY }}>Claimed Refund — {selectedRefundRow.date}</Typography>
                  <Box component="button" onClick={() => setSelectedRefundRow(null)} sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "2rem", height: "2rem", borderRadius: "50%", border: `2px solid ${Colors.ACCENT_GRAY}`, background: "transparent", cursor: "pointer", "&:hover": { background: Colors.BACKSHADE_GRAY } }}><XSvg /></Box>
                </Box>
                <Box sx={{ borderRadius: "1rem", background: Colors.BACKSHADE_GRAY, p: "1.25rem" }}>
                  {[{ label: "Reason", value: selectedRefundRow.reason }, { label: "Requested By", value: selectedRefundRow.requestedBy }, { label: "Approved By", value: selectedRefundRow.approvedBy }, { label: "Refund Total", value: `$${selectedRefundRow.amount.toFixed(2)}` }].map(({ label, value }) => (
                    <Box key={label} sx={{ display: "grid", gridTemplateColumns: "10rem 0.75rem 1fr", alignItems: "center", gap: "0.75rem", mb: "0.75rem" }}>
                      <Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{label}</Typography>
                      <Typography sx={{ color: Colors.MAIN_GRAY }}>:</Typography>
                      <Box sx={{ borderRadius: "0.5rem", background: Colors.WHITE, px: "0.75rem", py: "0.5rem" }}><Typography sx={{ fontSize: "var(--fs-2xs)", fontWeight: 600, color: Colors.MAIN_GRAY }}>{value}</Typography></Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          )}

          {/* Manager Access Modal */}
          {showManagerModal && (
            <ManagerCodeModal open={showManagerModal} onClose={() => setShowManagerModal(false)} title="Reports Access" task="to view customer reports" onDone={() => { setReportsUnlocked(true); setShowManagerModal(false); setSelectedTab(2); }} requestedByUserId={user?.id} actionType="REPORTS_ACCESS" />
          )}

          <AddNoteModal open={showAddNote} onClose={() => setShowAddNote(false)} onAdd={(note) => setReportNotes(note)} initialNote={reportNotes} />

          {openPdfModal && (<PdfViewModal open={openPdfModal} onClose={() => setOpenPdfModal(false)} onOpenAccessModal={() => setDownloadAccessOpen(true)} onOpenPrintAccessModal={() => setPrintAccessOpen(true)} reportName={selectedReport} name={pdfCustomerName} customerId={pdfCustomerId} address={pdfAddress} contactNumber={pdfContact} total={selectedReportData?.totalAmount ?? 0} month={selectedReportData ? formatReportPeriod(selectedReportData) : "—"} reportData={customerReportData} notes={reportNotes} />)}
          {downloadAccessOpen && (<PDFDownloadAccessModal open={downloadAccessOpen} onClose={() => setDownloadAccessOpen(false)} onAccessGranted={handleDownload} />)}
          {printAccessOpen && (<PDFPrintAccessModal open={printAccessOpen} onClose={() => setPrintAccessOpen(false)} onPrintAccessGranted={handlePrint} />)}

        </Box>
      </Box>
    </PosLayout>
  );
};

export default CustomerAnalysisScreen;
